<template>
  <section class="place-results">
    <h3 class="result-heading">位置</h3>
    <p v-if="loading" class="place-state">正在搜索位置...</p>
    <p v-else-if="error" class="place-state place-error">{{ error }}</p>
    <p v-else-if="places.length === 0" class="place-state">未找到相关位置</p>
    <template v-else>
      <button
        v-for="place in places"
        :key="place.id || `${place.longitude},${place.latitude}:${place.name}`"
        class="place-item"
        type="button"
        @click="emit('selectPlace', place)"
      >
        <strong>
          <template
            v-for="(part, index) in splitTextByKeyword(place.name, keyword)"
            :key="'name-' + index"
          >
            <span :class="{ highlight: part.matched }">{{ part.text }}</span>
          </template>
        </strong>
        <span class="place-address">
          <template
            v-for="(part, index) in splitTextByKeyword(placeAddress(place), keyword)"
            :key="'address-' + index"
          >
            <span :class="{ highlight: part.matched }">{{ part.text }}</span>
          </template>
        </span>
      </button>
    </template>
  </section>
</template>

<script setup>
import { splitTextByKeyword } from '../common/js/search';

defineOptions({name: 'PlaceList'});

defineProps({
  places: {
    type: Array,
    default: () => []
  },
  loading: Boolean,
  error: {
    type: String,
    default: ''
  },
  keyword: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['selectPlace']);

function placeAddress (place) {
  return place.address || [place.districtName, place.cityName].filter(Boolean).join(' ');
}
</script>

<style scoped>
.place-results {
  padding: 8px 12px 16px;
  background: var(--surface-bg);
}

.place-results > .result-heading {
  margin: 4px 0 6px;
  color: var(--text-main);
  font-size: 16px;
}

.place-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 11px 0;
  border: none;
  border-bottom: 1px solid var(--border-color);
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.place-item strong {
  color: var(--text-main);
  font-size: 15px;
  line-height: 21px;
}

.place-address,
.place-state {
  margin: 3px 0 0;
  color: var(--text-faint);
  font-size: 13px;
  line-height: 19px;
}

.place-item .highlight {
  color: var(--accent-color);
  font-weight: 700;
}

.place-error {
  color: var(--accent-color);
}
</style>
